<template>
  <ListItemsWithTableLayout>
    <template #body>
      <HandlerAccessDenied :is-denied="isDenied">
        <WorkbookFilterForm
          :isFilterEnabled="isFilterEnabled"
          @toggle-filter="isFilterEnabled = !isFilterEnabled"
          @set-filter="setFilter"
        ></WorkbookFilterForm>
        <TopListWorkbooksPanel
          @set-common-filter="setCommonFilter"
          @toggle-filter="isFilterEnabled = !isFilterEnabled"
          :isFilterEnabled="isFilterEnabled"
          :isFilterSetted="isFilterSetted"
        ></TopListWorkbooksPanel>
        <div
          id="table-container"
          class="table-container flex flex-col"
          :class="[
            filteredWorkbooks && filteredWorkbooks.length == 0
              ? 'empty'
              : 'filled',
          ]"
        >
          <WorkbooksTable
            :workbooks="filteredWorkbooks"
            :isActiveFirst="activeFirstFromStore"
            :isLoading="isLoading"
            :rowsCount="rowsCount(46, 20) * tableDisplaySettings.first"
            @sort-table="sortTable"
            @update-table="updateWorkbooksList"
          ></WorkbooksTable>
          <EmptyTableMessage
            v-if="
              filteredWorkbooks && filteredWorkbooks.length == 0 && !isLoading
            "
          >
            <template #text>
              Примените другой фильтр или создайте первый воркбук.
              <br />
              Для этого кликните на кнопку "Создать воркбук".
            </template>
          </EmptyTableMessage>
        </div>
        <Paginator
          v-model:first="tableDisplaySettings.first"
          @update:first="updateWorkbooksList"
          :rows="1"
          class="s-paginator"
          :totalRecords="store.workbookPagesCount"
          template="PrevPageLink CurrentPageReport NextPageLink"
          currentPageReportTemplate="{first} из {totalRecords}"
        />
      </HandlerAccessDenied>
    </template>
  </ListItemsWithTableLayout>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";

import Paginator from "primevue/paginator";
import ListItemsWithTableLayout from "@/widgets/layouts/ListItemsWithTableLayout.vue";
import TopListWorkbooksPanel from "@/entities/dictionaries/workbooks/panels/TopListWorkbooksPanel.vue";
import EmptyTableMessage from "@/entities/segments/EmptyTableMessage.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";
import WorkbooksTable from "@/entities/dictionaries/workbooks/WorkbooksTable.vue";
import WorkbookFilterForm from "@/entities/dictionaries/workbooks/forms/WorkbookFilterForm.vue";

import { useDashbordsStore, WorkbookParams } from "@/store/analytics/dasboards";
import { useAuthStore } from "@/store/auth/login";
import { rowsCount } from "@/services/utils/Pagination";
import {
  setWorkbooksParamsByFilter,
  FilterForm,
} from "@/services/dictionaries/workbooks";

const store = useDashbordsStore();
const authStore = useAuthStore();
const isLoading = ref(false);
const isFilterEnabled = ref(false);
const isFilterSetted = ref(false);
const tableDisplaySettings = ref({
  first: 0,
  orderField: "",
  commonFilter: "",
  filter: {} as FilterForm,
});

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(
    ["system:read", "system:edit"],
    ["dictionaries:read", "dictionaries:edit"],
    ["dictionaries:read", "analytics:edit"]
  );
});

const filteredWorkbooks = computed(() => {
  return store.workbooksList;
});

const activeFirstFromStore = computed(() => store.activeFirst);

onMounted(() => {
  loadData();
});

const loadData = () => {
  isLoading.value = true;
  updateWorkbooksList();
};

const setCommonFilter = (filter: string) => {
  tableDisplaySettings.value.commonFilter = filter;
  updateWorkbooksList();
};

const sortTable = (order_by: string) => {
  tableDisplaySettings.value.orderField = order_by;
  updateWorkbooksList();
};

const setFilter = (filter: FilterForm, isSetted: boolean) => {
  tableDisplaySettings.value.filter = filter;
  isFilterSetted.value = isSetted;
  updateWorkbooksList();
};

const updateWorkbooksList = () => {
  let isEnded = false;
  setTimeout(() => {
    if (!isEnded) {
      isLoading.value = true;
    }
  }, 200);
  const params: WorkbookParams = {
    page: tableDisplaySettings.value.first + 1,
    per_page: rowsCount(46, 20),
  };

  setWorkbooksParamsByFilter(params, tableDisplaySettings.value);

  store.getWorkbooks(params).finally(() => {
    isLoading.value = false;
    isEnded = true;
  });
};

let resizeTimeout: number;

window.addEventListener("resize", function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(updateWorkbooksList, 200);
});
</script>
